export enum TokenStatus {
	EXPIRED = "EXPIRED",
	OPEN = "OPEN",
	INVALID = "INVALID",
	USED = "USED",
}
